module.exports = {"370784001":"兴安街道","370784003":"新安街道","370784004":"凌河街道","370784100":"景芝镇","370784104":"官庄镇","370784107":"大盛镇","370784111":"石埠子镇","370784112":"石堆镇","370784118":"柘山镇","370784119":"辉渠镇","370784120":"吾山镇","370784121":"金冢子镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370784.json
// module id = 1540
// module chunks = 0